import { render, staticRenderFns } from "./CancelledTripsToday.vue?vue&type=template&id=604d5322"
import script from "./CancelledTripsToday.vue?vue&type=script&lang=js"
export * from "./CancelledTripsToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports